// Admin-bucket dock registry entries (§5.3 / SC-6).
// Extracted from `sectionRegistry.tsx` for file-size hygiene.

import type { DockSectionDefinition } from "./sectionTypes";
import {
  ADMIN_MEMBER_APPROVAL_ROLES,
  ADMIN_ORG_UNSENT_ROLLUP_ROLES,
} from "@/lib/admin/adminDockRoles";
import { ActivityDockPendingApprovalsSection } from "./sections/ActivityDockPendingApprovalsSection";
import { ActivityDockOrgUnsentRollupSection } from "./sections/ActivityDockOrgUnsentRollupSection";

export const ADMIN_DOCK_SECTION_ENTRIES: readonly DockSectionDefinition[] = [
  {
    id: "pending-member-approvals",
    roleGate: { roles: [...ADMIN_MEMBER_APPROVAL_ROLES] },
    render: (ctx) => (
      <ActivityDockPendingApprovalsSection
        pendingMemberApprovalCounts={ctx.pendingMemberApprovalCounts ?? null}
        currentMode={ctx.currentMode}
        onOpenAdmin={ctx.onOpenAdmin}
      />
    ),
    bucketRelevance: ["admin"],
    modeRelevance: ["admin", "dashboard"],
    hasSignal: (ctx) => (ctx.pendingMemberApprovalTotal ?? 0) > 0,
  },
  {
    // Structural stub: `orgUnsentRollupCount` is null until cross-user unsent
    // API lands. No `hasSignal` — P1 panel-only per §5.3 (no obligation peek).
    id: "org-unsent-rollup",
    roleGate: { roles: [...ADMIN_ORG_UNSENT_ROLLUP_ROLES] },
    render: (ctx) => (
      <ActivityDockOrgUnsentRollupSection
        orgUnsentRollupCount={ctx.orgUnsentRollupCount ?? null}
        currentMode={ctx.currentMode}
        onOpenDashboard={ctx.onOpenDashboard}
      />
    ),
    bucketRelevance: ["admin"],
  },
];
